module.exports = __webpack_public_path__ + "8ea34ecc205f138eb285b151e41f0a1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/img/header_2.jpg
// module id = 303
// module chunks = 0